import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import 'firebase/storage';

// firebase init - add your own config here
const firebaseConfig = {
    apiKey: "AIzaSyAMxppitwPl18fyQulz0zsZTRgtkVjRQS8",
    authDomain: "zwara-radio.firebaseapp.com",
    databaseURL: "https://zwara-radio.firebaseio.com",
    projectId: "zwara-radio",
    storageBucket: "zwara-radio.appspot.com",
    messagingSenderId: "181510169074",
    appId: "1:181510169074:web:d2bfcdd9682f7323ed8b6b",
    measurementId: "G-RM5E4KJCNZ"
}

firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage();

// collection references
const kidsCollection = db.collection('kids')
const otherNarrationsCollection = db.collection('otherNarrations')
const qalonNarrationCollection = db.collection('qalonNarration')
const recordingsCollection = db.collection('recordings')
const foldersCollection = db.collection('folders')

// export utils/refs
export {
    db,
    auth,
    storage,
    recordingsCollection,
    kidsCollection,
    otherNarrationsCollection,
    qalonNarrationCollection,
    foldersCollection,
}